import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=12254e10&scoped=true&"
import script from "./routes.vue?vue&type=script&lang=js&"
export * from "./routes.vue?vue&type=script&lang=js&"
import style0 from "./routes.vue?vue&type=style&index=0&id=12254e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12254e10",
  null
  
)

export default component.exports